<template><div><h2>Actionsheet</h2>
<ul>
<li>[change] upgrade to vue@2.0, use <code>v-model</code> instead of <code>:show.sync</code></li>
<li>[feature] add prop close-on-clicking-mask</li>
</ul>
<h2>Alert</h2>
<ul>
<li>[change] use <code>v-model</code> instead of <code>:show.sync</code></li>
<li>[todo] fix animation</li>
</ul>
<h2>Badge</h2>
<ul>
<li>[todo] when used in a cell, it might not be that center</li>
</ul>
<h2>ButtonTab</h2>
<ul>
<li>[enhance] remove tap highlight</li>
</ul>
<h2>Checker</h2>
<ul>
<li>[feature] Support Object value #705</li>
</ul>
<h2>Checklist</h2>
<ul>
<li>[change] it does not show errors by default, handle errors by on-error events</li>
<li>[feature] add slot:footer slot:after-title</li>
<li>[change] if value.length === max, the left items will be disabled</li>
<li>[change] default required value is false</li>
</ul>
<h2>ColorPicker</h2>
<h2>Countdown</h2>
<ul>
<li>[deprecated] This component is no longer maintained</li>
</ul>
<h2>Countup</h2>
<ul>
<li>[feature] Add prop:start</li>
<li>[change] Update countup -&gt; countup.js</li>
</ul>
<h2>FormPreview</h2>
<h2>LoadMore</h2>
<ul>
<li>[feature] Add <code>load-more</code> component</li>
</ul>
<h2>Popover</h2>
<ul>
<li>[todo] wrong position if changing locale</li>
</ul>
<h2>Toast</h2>
<ul>
<li>[change] use <code>v-model</code> instead of <code>:show.sync</code></li>
<li>[change] do not show mask by default</li>
<li>[feature] add prop:isShowMask</li>
</ul>
<h2>XInput</h2>
<h2>XNumber</h2>
<ul>
<li>[change] set <code>fiilable</code> default value to <code>false</code></li>
</ul>
</div></template><script>
export default {
  head: {"title":" | VUX - Vue 移动端 UI 组件库","ignoreSuffixChar":"|"}
}
  </script>


// WEBPACK FOOTER //
// v2.0.0_en-281.vue?a65759b0